import { get, post } from './../Config/config';

export const Auth = {
  login: (data) => post('/auth/login', data),
  verify2FA: (data) => post('/auth/verify-2fa', data),
  register: (data) => post('/auth/register', data),
  forgotPassword: (data) => post('/auth/forgot-password', data),
  resetPassword: (data) => post('/auth/reset-password', data),
  me: () => get('/auth/me'),
};
